import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

import './headline.scss';

const startAnimation = (timeline, section) => {
  timeline.from('.Headline__primary', { opacity: 0 }).from('.Headline__secondary', { opacity: 0 }, '+0.25');
};
const Headline = ({ primaryText, secondaryText }) => {
  const heading = useRef(null);
  const timeline = gsap.timeline({ defaults: { opacity: 0 } });

  useEffect(() => startAnimation(timeline, heading.current), [timeline]);

  return (
    <h1 ref={heading} className="Headline">
      <span className="Headline__primary">{primaryText}</span>
      <span className="Headline__secondary">{secondaryText}</span>
    </h1>
  );
};

export default Headline;
